export default {"src":"/_next/static/media/18-year-logo.a1ab59b9.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};